import { defineMessages } from 'react-intl';

export const BrowseGenresKeys = Object.freeze({
  GENRE_CATEGORIES_HAVE_LOADED: 'GENRE_CATEGORIES_HAVE_LOADED',
  GENRE_CATEGORY_TOKENS: 'GENRE_CATEGORY_TOKENS',
  GENRE_CATEGORY_TOKENS_TO_GENRE_IDS: 'GENRE_CATEGORY_TOKENS_TO_GENRE_IDS',
} as const);

export const MyStationsGenreCategoryTokens = Object.freeze([
  'country',
  'hip-hoprap',
  'pop',
  'rbsoulfunk',
  'rock',
] as const);

export const BrowseGenresMessages = defineMessages({
  browseGenreCategoriesTitle: {
    id: 'Browse.browseGenreCategoriesTitle',
    defaultMessage: 'Genres',
  },

  browseGenreCategoriesSubTitle: {
    id: 'Browse.browseGenreCategoriesSubTitle',
    defaultMessage: "Not sure what you want to hear? Start browsing stations you'll love.",
  },

  browseGenresTitle: {
    id: 'Browse.browseGenresTitle',
    defaultMessage: '{categoryName}',
  },
} as const);
